import { IValidationRule } from "@/types"

const colorValidationRules: { [s: string]: IValidationRule } = {
    code: {
        required: true,
        type: "hexColor6Char"
    },
}

export default colorValidationRules
